import { datadogRum } from '@datadog/browser-rum';
import { ACCOUNTLESS_APP_ENTRY_COOKIE_NAME } from 'stash/constants/session';
import { deleteCookie, getCookie } from 'stash/utils/cookies';
import type { CookieValue } from 'stash/utils/cookies';

/**
 * Resolves whether the current user is admitted to the accountless app entry
 * experience, from the cookie web-reg writes on admission.
 *
 * `sessionUuid` is passed in rather than read here because on log in the uuid
 * cookie is written after AUTH_SESSION_START dispatches.
 *
 * A value that does not match the session uuid is a leftover from a previous
 * user on a shared browser, so it is ignored and cleared. An absent session
 * uuid is not a mismatch — the uuid cookie expires with the session while the
 * admission cookie lasts 7 days — so the cookie is left alone to be resolved
 * again once the user is authenticated.
 */
export const resolveAccountlessAppEntry = (sessionUuid: CookieValue): boolean => {
	const admittedUuid = getCookie(ACCOUNTLESS_APP_ENTRY_COOKIE_NAME);

	if (!admittedUuid || !sessionUuid) {
		return false;
	}

	if (admittedUuid === sessionUuid) {
		return true;
	}

	deleteCookie(ACCOUNTLESS_APP_ENTRY_COOKIE_NAME);
	datadogRum.addAction('AccountlessAppEntry_UuidMismatch');

	return false;
};
